/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {map} from 'rxjs/operators';
import {inject, Injectable} from '@angular/core';
import {HttpClient,  HttpHeaders,HttpEvent,HttpRequest} from "@angular/common/http";
import {Observable} from "rxjs";
import {APP_CONFIG} from '../app.config';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const httpOptionsForMultipart ={
  headers: new HttpHeaders({'Content-Type':'application/x-www-form-urlencoded'})
};

@Injectable()
export class EcsUploadDownloadService {

  private baseUrl;


    constructor(private http: HttpClient) {
      this.baseUrl = inject(APP_CONFIG).baseUrl + '/api/pga-ecs/ecs';
    }


  private doDownload(ECSFilePath: string) {
    const url = `${this.baseUrl}/${ECSFilePath}`;
    return this.http
      .get(url, { responseType: 'blob'})
  }

  downloadAttachment(ECSFilePath: string)  {
    console.log('downloadAttachment')
    const fileName = ECSFilePath.substr(ECSFilePath.indexOf('=')+1);
    return this.doDownload(ECSFilePath).subscribe(
      res => {
        const url = window.URL.createObjectURL(res);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
      }, error => {
        console.log('download error:', JSON.stringify(error));
      }, () => {
        console.log('Completed file download.')
      });



  }

  uploadAttachment(type:string, id:number, localFilePath:string): Observable<string> {
    const url= `${this.baseUrl}/path/${type}/${id}`;
    const body = '{filePath:'+localFilePath+'}';
    return this.http.post(url,body,httpOptions).pipe(
      map(remoteFilePath=>remoteFilePath as string));
  }

  uploadAttachmentMultipart(type:string, id:number, localFile:File): Observable<HttpEvent<{}>> {
    console.log('uploadAttachment')
    const url= `${this.baseUrl}/${type}/${id}`;
    const formData: FormData = new FormData();
    formData.append('file',localFile);
    console.log(localFile)

    const req = new HttpRequest('POST',url,formData,{
      reportProgress:true,
      responseType: 'text'
    });
    return this.http.request(req);

  }

}
